import { alertFailure, errorText, ShownError } from "../../utils/error-messages";

export const initBookingInvite = () => {
  const bookingInvite = document.getElementById("booking-invite") as HTMLDivElement;

  if (!bookingInvite) {
    return;
  }

  bookingInvite.addEventListener("click", () => {
    const parentId = bookingInvite.dataset.parentId;
    const spinner = bookingInvite.querySelector(".spinner") as HTMLSpanElement;

    spinner.classList.remove("d-none");

    fetch(`/website-api/bookings/invite/${parentId}/`, {
      credentials: "same-origin",
      method: "post",
    })
      .then((response) => {
        spinner.classList.add("d-none");

        if (response.status === 401) {
          throw new Error("Unauthorized");
        }
        if (response.status === 429) {
          throw new ShownError(errorText("rateLimited"));
        }
        if (response.status === 500) {
          throw new Error("Service is unavailable");
        }

        return response.json();
      })
      .then((jsonResponse) => {
        if (jsonResponse.metadata.code >= 400) {
          if (jsonResponse.metadata.errors) {
            alert(jsonResponse.metadata.errors[0].error);

            return;
          }

          if (jsonResponse.metadata.error_message) {
            alert(jsonResponse.metadata.error_message);

            return;
          }

          alert(errorText("generic"));

          return;
        }

        location.reload();
      })
      .catch(alertFailure);
  });
};
